import React from "react";

const Confidentiality = () => {
    return <div className = 'body'>Конфиденциальность</div>;
}

export default Confidentiality;
